import React, { useState } from 'react'
import {
    ClickAwayListener,
    Paper,
    Popper,
} from '@material-ui/core'
import DefaultMarker from 'src/common/razzle-platform-map/components/DefaultMarker'



export default function MapMarker(props) {
    const [anchorEl, setAnchorEl] = useState(null)
    const [inProgress, setInProgress] = useState(false)

    const { item, isHovered, marker, markerPreviwItem: MarkerPreviewItem, itemRoutes } = props
    const open = Boolean(anchorEl)
    const id = open ? 'simple-popper' : undefined


    const Marker = marker ? marker : DefaultMarker

    return (
        <div>
            <Marker
                handleClick={(event) => setAnchorEl(anchorEl ? null : event.currentTarget)}
                item={item}
                isHovered={isHovered}
            />
            <Popper
                className="bottom-arrow absolute z-10"
                placement="top"
                id={id}
                open={open}
                anchorEl={anchorEl}
                transition
                modifiers={{
                    arrow: {
                        enabled: true,
                    },
                }}
            >
                {({ TransitionProps }) => (
                    <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
                        <Paper className="w-64" style={{ borderRadius: '12px' }}>
                            <MarkerPreviewItem
                                item={item}
                                itemRoutes={itemRoutes}
                            />
                        </Paper>
                    </ClickAwayListener>
                )}
            </Popper>
        </div>
    )
}
